export default {
  /**
   * Helper for ingredient-list.vue so that qty can be updated dynamically
   * when a recipe is scaled.
   */
  getScaledIngredients: (state: ArticleState) => (ingredients: Array<Object>) => {
    // scaled mode
    // return new array with updated quantities
    if (state.mode === 'scaled' && state.ingredients) {
      return ingredients.map((ingredient) => ({
        ...ingredient,

        // scaled properties
        metric_qty: state.ingredients[ingredient.id]
          ? state.ingredients[ingredient.id].metricQty
          : ingredient.metric_qty,
        imperial_qty: state.ingredients[ingredient.id]
          ? state.ingredients[ingredient.id].imperialQty
          : ingredient.imperial_qty,
      }))
    }

    // no changes, not scaled
    return ingredients
  },
}
